module.exports = __webpack_public_path__ + "static/media/MapPin.7f9fa6c3.svg";